import { getNoManagerRoleUsersByCompanyId, getManagerRoleUsersByCompanyId } from "@/apis"
import { USER_LIST_REQUEST, USER_LIST_SUCCESS, USER_LIST_FAIL } from "../action-types/userList"

const userListRequestCreator = () => {
    return {
        type: USER_LIST_REQUEST,
    }
}

const userListSuccessCreator = (data) => {
    return {
        type: USER_LIST_SUCCESS,
        payload: data,
    }
}

const userListFailCreator = (error) => {
    return {
        type: USER_LIST_FAIL,
        payload: error,
    }
}

export const fetchNoManagerUserList = (companyId) => async (dispatch) => {
    dispatch(userListRequestCreator)
    try {
        const userList = await getNoManagerRoleUsersByCompanyId(companyId)
        const userListData = userList.data.users
        dispatch(userListSuccessCreator(userListData))
    } catch (error) {
        dispatch(userListFailCreator(error.data.message))
    }
}

export const fetchManagerUserList = (companyId) => async (dispatch) => {
    dispatch(userListRequestCreator)
    try {
        const userList = await getManagerRoleUsersByCompanyId(companyId)
        const userListData = userList.data.users
        dispatch(userListSuccessCreator(userListData))
    } catch (error) {
        dispatch(userListFailCreator(error.data.message))
    }
}
